import { render, staticRenderFns } from "./ViewIncoterm.vue?vue&type=template&id=23acb66b"
import script from "./ViewIncoterm.vue?vue&type=script&lang=js"
export * from "./ViewIncoterm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports